'use client'

import { useTaskFlowStore, type TaskFlowRequest } from './taskFlowStore'

export function openTaskFlow(request: TaskFlowRequest) {
  useTaskFlowStore.getState().openTaskFlow(request)
}

export function closeTaskFlow() {
  useTaskFlowStore.getState().closeTaskFlow()
}

export function resetTaskFlow() {
  useTaskFlowStore.getState().resetTaskFlow()
}